import React, { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import dayjs from "dayjs";
import PhoneInput from "react-phone-number-input";

let InputFieldImg = ({ icon }) => {
  console.log("icon:>>>>>>>>>>", icon);
  switch (icon) {
    case "email":
      return "input-email";
    case "password":
      return "input-password";
    default:
      return null;
  }
};
export const TextField = ({
  formik,
  name,
  label = false,
  placeholder,
  icon = null,
  type = "text",
  maxLength = false,
  disabled = false,
  // nested = false
}) => {
  const { errors, values, touched } = formik;
  console.log("errors", errors);

  return (
    <>
      {label ? (
        <label htmlFor="" className="form-label">
          {label}
        </label>
      ) : null}
      <div className={icon ? "inputIcon" : ""}>
        <input
          name={name}
          onChange={formik.handleChange}
          style={{ color: "black" }}
          type={type}
          className={`form-control`}
          // ${InputFieldImg({ icon: name })} ${
          //   icon ? "iconInputLeft" : ""
          // }

          value={formik.values[name]}
          placeholder={placeholder}
          // format={"dd-mm-yyyy"}
          maxLength={maxLength ? maxLength : 50}
          max={type == "date" ? dayjs().format("YYYY-MM-DD") : ""}
          disabled={disabled}
        />
      </div>

      {errors[name] ? <div className="error">{errors[name]}</div> : null}
    </>
  );
};

export const UserCheckboxFeild = ({
  formik,
  name,
  disabled = false,
  value = "",
  label = "",
  module = "",
  // nested = false
}) => {
  const { errors, values, touched } = formik;
  console.log("values", values[name]);

  return (
    <>
      <div className="inputIcon">
        <input
          className="form-check-input"
          type="checkbox"
          checked={values[name] == "Verified" ? true : false}
          id="flexCheckChecked"
          name={name}
          disabled={disabled}
          onChange={formik.handleChange}
        />
      </div>
      {label ? (
        <label htmlFor="" className="form-label">
          {label}
        </label>
      ) : null}
    </>
  );
};

export const CheckboxFeild = ({
  formik,
  name,
  disabled = false,
  value = "",
  label = "",
  // nested = false
}) => {
  const { errors, values, touched } = formik;
  console.log("values", values[name]);

  return (
    <>
      <div className="inputIcon">
        <input
          className="form-check-input"
          type="checkbox"
          id="flexCheckChecked"
          name={name}
          disabled={disabled}
          onChange={formik.handleChange}
        />
      </div>
      {label ? (
        <label htmlFor="" className="form-label">
          {label}
        </label>
      ) : null}
    </>
  );
};

export const RadioFeild = ({
  formik,
  name,
  disabled = false,
  radioValues = "",
  label = "",
  // nested = false
}) => {
  const { errors, values, touched } = formik;
  console.log("values", values[name]);
  radioValues = radioValues.split(",");
  console.log("radioValues:::::::::", radioValues);
  return (
    <>
      <div className="inputIcon">
        {radioValues.map((value, index) => (
          <>
            <input
              className="form-radio-input"
              type="radio"
              checked={values[name] == value ? true : false}
              id="flexRadioChecked"
              name={name}
              disabled={disabled}
              onChange={formik.handleChange}
            />{" "}
            &nbsp;
            <span style={{ position: "relative", bottom: "6px" }}>{value}</span>
            &nbsp;&nbsp;
          </>
        ))}
      </div>
      {label ? (
        <label htmlFor="" className="form-label">
          {label}
        </label>
      ) : null}
    </>
  );
};

export const FileFeild = ({
  formik,
  name,
  label = false,
  setFormikPhotoValue,
  previewPhoto,
}) => {
  return (
    <>
      {label ? (
        <label htmlFor="" className="form-label">
          {label}
        </label>
      ) : null}
      <div className="inputIcon">
        <input
          type="file"
          name={name}
          onChange={(event) =>
            setFormikPhotoValue(event.currentTarget.files[0])
          }
        />
        <img
          src={previewPhoto}
          style={{
            height: "60px",
            width: "60px",
            border: "1px solid #5e2b97",
            borderRadius: "50%",
          }}
        />
      </div>
      {/* {errors[name] && touched[name] ? (
        <div className="error">{errors[name]}</div>
      ) : null} */}
    </>
  );
};

export const PhoneComponent = ({
  formik,
  name,
  label = false,
  placeholder,
  icon = null,
  type = "text",
  disabled = false,
}) => {
  const { errors, values, touched } = formik;

  console.log("formik :>> ", formik);
  let value = formik.values[name];

  const handleChange = (value) => {
    formik.setFieldValue(name, value);
  };

  return (
    <>
      {label ? (
        <label htmlFor="" className="form-label">
          {label}
        </label>
      ) : null}
      <PhoneInput
        country="AU"
        name={name}
        countryCallingCodeEditable={false}
        placeholder="Enter MSN"
        value={formik.values[name]}
        onChange={handleChange}
        defaultCountry="AU"
        className="form-control"
        disabled={disabled}
      />{" "}
      {errors[name] ? <div className="error">{errors[name]}</div> : null}
    </>
  );
};
